import * as i0 from '@angular/core';
import * as i1 from './mapping';
import * as i2 from '@angular/cdk/bidi';
import * as i3 from '@angular/cdk/scrolling';
import * as i4 from '@angular/cdk/overlay';
import * as i5 from '@angular/cdk/portal';
export const NbCdkMappingModuleNgFactory:i0.NgModuleFactory<i1.NbCdkMappingModule> = (null as any);
var _decl0_0:i2.Dir = (<any>(null as any));
var _decl0_1:i3.CdkFixedSizeVirtualScroll = (<any>(null as any));
var _decl0_2:i3.CdkScrollable = (<any>(null as any));
var _decl0_3:i3.CdkVirtualForOf<any> = (<any>(null as any));
var _decl0_4:i3.CdkVirtualScrollViewport = (<any>(null as any));
var _decl0_5:i4.CdkConnectedOverlay = (<any>(null as any));
var _decl0_6:i4.CdkOverlayOrigin = (<any>(null as any));
var _decl0_7:i5.CdkPortal = (<any>(null as any));
var _decl0_8:i5.CdkPortalOutlet = (<any>(null as any));
var _decl0_9:i1.NbPortalDirective = (<any>(null as any));
var _decl0_10:i1.NbPortalOutletDirective = (<any>(null as any));
var _decl0_13:i4.OverlayModule = (<any>(null as any));
var _decl0_14:i5.PortalModule = (<any>(null as any));
var _decl0_15:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_16:i0.ElementRef<any> = (<any>(null as any));
